module.exports = __webpack_public_path__ + "static/media/research.56f2c6b5.svg";